module.exports = __webpack_public_path__ + "static/img/peel-hugo.f682b32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peel-hugo.jpg
// module id = sHi+
// module chunks = 0